// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning-fee-low[data-v-e8dc92d6]{color:#b98e0d}.warning-fee-low i[data-v-e8dc92d6]{font-size:.18rem}", ""]);
// Exports
module.exports = exports;
